import { useMemo } from 'react';
import styles from './TenantSelector.module.css';
import { TenantSelectorBody } from './TenantSelectorBody';
import { TenantSyncModeSelector } from './TenantSyncModeSelector';
import type { TenantSelectorProps } from './types';

export function TenantSelector({
  tenantSelectionType,
  selectedTenantIds,
  onChange,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  disabled = false,
  tenantRowData,
  listOnly = false,
  isLoading = false,
}: TenantSelectorProps) {
  const allCurrentTenantIds = useMemo(() => Object.keys(tenantRowData), [tenantRowData]);

  const allCurrentAndFuture = tenantSelectionType === 'all';

  const handleSelectAllCurrentAndFuture = () => {
    if (disabled) {
      return;
    }
    onChange('all', selectedTenantIds);
  };
  const handleSwitchToSelectedMode = () => {
    if (disabled) {
      return;
    }
    const newIds = selectedTenantIds.length > 0 ? selectedTenantIds : allCurrentTenantIds;
    onChange('selected', newIds);
  };

  return (
    <section className={listOnly ? undefined : styles.section}>
      {!listOnly && (
        <TenantSyncModeSelector
          allCurrentAndFuture={allCurrentAndFuture}
          onAllMode={handleSelectAllCurrentAndFuture}
          onSelectedMode={handleSwitchToSelectedMode}
          allTenantsSelectionDescription={allTenantsSelectionDescription}
          selectedTenantsSelectionDescription={selectedTenantsSelectionDescription}
          disabled={disabled}
        />
      )}

      <div className={styles.body}>
        <TenantSelectorBody
          tenantSelectionType={tenantSelectionType}
          selectedTenantIds={selectedTenantIds}
          tenantRowData={tenantRowData}
          disabled={disabled}
          onChange={onChange}
          hideToolbar={listOnly}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
}
